// extracted by mini-css-extract-plugin
module.exports = {"card":"users_card__2uogy","placeholderShimmer":"users_placeholderShimmer__2cwAh"};